/**
 * SDK version, generated from package.json by scripts/sync-version.ts.
 *
 * Do not edit by hand — it is regenerated on `build`. Committed so source and
 * test runs work without a build; kept in sync with package.json at publish
 * time so the User-Agent never reports a stale version.
 */
export const SDK_VERSION = '1.6.10'
